import {Component, Input, OnInit} from '@angular/core';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import * as moment from 'moment';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {CalendarService} from '../../../../services/calendar.service';
import { FirebaseStorageService } from '../../../../services/firebase-storage.service';
import { ShowPreviewFilesComponent } from '../../../../utils/show-preview-files/show-preview-files.component';
import { v4 as uuidv4 } from 'uuid';
import { finalize } from 'rxjs/operators';
import { FilesService } from '../../../../services/files.service';
import { AddDocumentComponent } from './add-document/add-document.component';
moment.locale('es');

@Component({
  selector: 'ngx-file-manager-requirement',
  templateUrl: './file-manager-requirement.component.html',
  styleUrls: ['./file-manager-requirement.component.scss'],
})
export class FileManagerRequirementComponent implements OnInit {

  loading = false;
  dataFormatted = {};
  openFolderDeliverables = false;
  showDeliverablesYear = [];
  deliverabledWithProjection = [];
  deliverablesParent = [];
  requirements = [];
  formatDate = 'YYYY/MM/DD';
  moment = moment;
  uploadPercentage = 0;
  isPeriodicityCustom = false

  @Input() deliverables: Array<any> = [];
  @Input() requirement: any;
  @Input() stationId: any;
  @Input() year = '';
  Object: any = Object;

  constructor(
    protected ref: NbDialogRef<FileManagerRequirementComponent>,
    private calendarService: CalendarService,
    private firebaseStorageService: FirebaseStorageService,
    private dialog: NbDialogService,
    private file: FilesService,
    private dialogService: NbDialogService
  ) { }

  async ngOnInit() {
    this.deliverabledWithProjection = []
    if (this.requirement.periodicity.toLowerCase() === 'eventual' || this.requirement.periodicity.toLowerCase() === 'variable') {
      this.isPeriodicityCustom = true
      for await (const deliverable of this.deliverables) {
        await this.deliverabledWithProjection.push({
          id: deliverable.id,
          start: new Date(moment(deliverable.date).format('YYYY/MM/DD')),
          meta: {
            withDelivered: deliverable.id,
            fileUrl: deliverable.files,
            parent: deliverable.parent,
            isDelivered: deliverable.delivered,
          }
        })
      }
    } else {
      this.deliverablesParent = await this.deliverables.filter(event => event.parent);
      await this.generateDeliverablesDataLastYear();
    }

    await this.formatData();
    if (this.year) this.openFolder(this.dataFormatted[this.year])
  }

  close() { this.ref.close(false); }

  async generateDeliverablesDataLastYear() {
    for (const deliverable of this.deliverablesParent) {
      if (deliverable.date) {
        switch (this.requirement.periodicity.toLowerCase()) {
          case 'quincenal':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 15, 'dias');
            break;
          case 'mensual':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 1, 'month');
            break;
          case 'bimestral':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 2, 'month');
            break;
          case 'trimestral':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 3, 'month');
            break;
          case 'semestral':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 6, 'month');
            break;
          case 'anual':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 1, 'year');
            break;
          case 'bienal':
            await this.fillPeriodicityDataIntoCalendarView(deliverable, 2, 'year');
            break;
          // case 'quinquenal':
          //   await this.fillPeriodicityDataIntoCalendarView(deliverable, 5, 'year');
          //   break;
          // UNIQ AND TEXT's WEAR
          default:
            await this.fillUniqDaraIntoCalendarView(deliverable);
            break;
        }
      }
    }
  }

  async fillUniqDaraIntoCalendarView(deliverable: any) {
    if (deliverable.delivered) {
      this.deliverabledWithProjection.push({
        id: deliverable.id,
        start: new Date(moment(deliverable.date).format(this.formatDate)),
        meta: { fileUrl: deliverable.files, parent: deliverable.parent, isDelivered: true },
      });
    } else {
      this.deliverabledWithProjection.push({
        id: deliverable.id,
        start: new Date(moment(deliverable.date).format(this.formatDate)),
        meta: { fileUrl: 0, parent: deliverable.parent, isDelivered: false },
      });
    }
  }

  async fillPeriodicityDataIntoCalendarView(deliverable: any, add: any, type: string) {
    let afterDate = moment(deliverable.date).subtract(2, 'year').format(this.formatDate);
    const diffYears = Math.abs(Number(moment(deliverable.date).year()) - (Number(moment().year()) + 1));
    const whenYearsFilling = Number(moment(deliverable.date).add(diffYears, 'years').year());
    // const monthDeliverableParent = moment(deliverable.date).month();
    let continueFilling = true;
    do {

      const foundDeliverable = this.deliverables.find(item =>
        moment(item.date).format(this.formatDate) === afterDate &&
        deliverable.legal_requirement_requirement_id === item.legal_requirement_requirement_id,
      );
      if (foundDeliverable && foundDeliverable.delivered) {
        this.deliverabledWithProjection.push({
          id: foundDeliverable.id,
          start: new Date(afterDate),
          meta: {
            withDelivered: foundDeliverable.id,
            fileUrl: foundDeliverable.files,
            parent: foundDeliverable.parent,
            isDelivered: foundDeliverable.delivered,
          },
        });
      } else if (foundDeliverable) {
        this.deliverabledWithProjection.push({
          id: foundDeliverable.id,
          start: new Date(afterDate),
          meta: {
            withDelivered: foundDeliverable.id,
            fileUrl: 0,
            parent: foundDeliverable.parent,
            isDelivered: foundDeliverable.delivered,
          },
        });
      } else {
        this.deliverabledWithProjection.push({
          id: deliverable.id,
          start: new Date(afterDate),
          meta: {
            withDelivered: false,
            fileUrl: 0,
            parent: moment(deliverable.date).format(this.formatDate) === afterDate,
            isDelivered: false,
          },
        });
      }
      continueFilling = Number(moment(afterDate).year()) < whenYearsFilling;
      afterDate = moment(afterDate).add(add, type).format(this.formatDate);
    } while (continueFilling);
  }

  async formatData() {
    this.dataFormatted = {};
    for await (const deliverable of this.deliverabledWithProjection) {
      const year = moment(deliverable.start).format('YYYY');
      if (year in this.dataFormatted) this.dataFormatted[year].push(deliverable);
        else this.dataFormatted[year] = [deliverable];
    }
  }

  async openFolder(deliverables: any) {
    this.showDeliverablesYear = deliverables;
    this.openFolderDeliverables = true;
  }

  openFile(url) {
    if (!url) return this.alert('Oops ocurrio algo', 'error', 'Url invalida');
    this.dialog.open(ShowPreviewFilesComponent, {
      hasScroll: true,
      context: { url },
    });
  }

  async delete(deliverable: any) {
    const result = await this.showAlertDeleteFile();
    if (result.value) {
      this.loading = true;
      const [err] = await this.calendarService.deleteDeliverable(deliverable.id);
      if (err) {
        this.loading = false;
        return this.alert('Oops, algo ocurrio', 'error', 'Error al borrar archivo. Intenta más tarde');
      }
      this.file.deleteFileByUrl(deliverable.meta.fileUrl[0]);
      deliverable.meta.fileUrl = 0
      deliverable.meta.isDelivered = false
      this.loading = false;
      return this.alert('Exito', 'success', 'Se elimino el archivo.');
    }
  }

  async editFile(event: any) {
    const { value: file } = await this.showAlertEditFile();
    if (file) {
      this.loading = true
      await this.firebaseStorageService.setPath('/deliverables');
      const filename = `${uuidv4()}_${file.name}`;
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);
      // observe percentage changes
      task.percentageChanges().subscribe((porcentaje) => this.uploadPercentage = Math.round(porcentaje));
      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            const data: any = {
              dependence_id: this.requirement.legal_requirement_dependence_id,
              date: moment(event.start).format('YYYY-MM-DD')
            }
            if (
              this.requirement.requirement || this.requirement.legal_requirement_requirement_id || this.requirement.pivot
            ) data.requirement_id = this.requirement.legal_requirement_requirement_id || this.requirement.pivot.legal_requirement_requirement_id || this.requirement.requirement.id
            else data.custom_requirement_id = this.requirement.id
            data.files = [url]
            data.parent = event.meta.parent
            data.delivered = true
            const [error] = await this.calendarService.editDeliverableFile(event.id, data);
            this.uploadPercentage = 0;
            this.loading = false;
            if (error) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
            this.file.deleteFileByUrl(event.meta.fileUrl[0]);
            event.meta.fileUrl = data.files;
            event.meta.isDelivered = data.delivered;
            await this.alert('Se cargo el fichero con exito', 'success');
          });
        })
      ).subscribe();
    }
  }

  async uploadFile(event: any) {
    return Swal.fire({
      title: 'Adjuntar archivo',
      input: 'file',
      inputAttributes: { autocapitalize: 'off' },
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: async (file) => this.store(file, event),
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }

  async validateDataYear(year: string) {
    if (this.dataFormatted[year]) return this.openFolder(this.dataFormatted[year]);
    this.openFolderDeliverables = false;
  }

  async showAlertDeleteFile() {
    return Swal.fire({
      title: 'Estas seguro?',
      icon: 'warning',
      text: 'Esta acción no se podrá revertir, el requisito legal pasara como no entregado en el apartado de "Calendario"',
      showCancelButton: true,
      confirmButtonColor: '#ff3d71',
      cancelButtonColor: '#4d4d4d',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    });
  }

  async addFile () {
    this.dialogService.open(AddDocumentComponent, { hasScroll: true }).onClose.subscribe(store => {
      if (store) this.store(store.file, { start: store.date, meta: { parent: false } })
    });
  }

  async showAlertEditFile() {
    return Swal.fire({
      title: 'Reemplazar archivo',
      input: 'file',
    });
  }

  async store (file: any, event: any) {
    this.loading = true
    await this.firebaseStorageService.setPath('/deliverables');
    const filename = `${uuidv4()}_${file.name}`;
    const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
    const task = this.firebaseStorageService.taskCloudStorage(filename, file);
    // observe percentage changes
    task.percentageChanges().subscribe((porcentaje) => this.uploadPercentage = Math.round(porcentaje));
    // get notified when the download URL is available
    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe(async (url) => {
          const data: any = {
            dependence_id: this.requirement.legal_requirement_dependence_id || this.requirement.pivot.legal_requirement_dependence_id,
            date: moment(event.start).format('YYYY-MM-DD')
          }
          if (
            this.requirement.requirement || this.requirement.legal_requirement_requirement_id || this.requirement.pivot
          ) data.requirement_id = this.requirement.legal_requirement_requirement_id || this.requirement.pivot.legal_requirement_requirement_id || this.requirement.requirement.id
          else data.custom_requirement_id = this.requirement.id
          data.files = [url]
          data.parent = event.meta.parent
          data.delivered = true
          const [error, response] = await this.calendarService.storeDeliverable(this.stationId, data);
          this.uploadPercentage = 0;
          this.loading = false;
          if (error) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
          event.meta = { fileUrl: data.files, isDelivered: data.delivered };
          if (this.isPeriodicityCustom) {
            console.log('insert deliverable custom', response.data)
            this.deliverables.push(response.data)
            this.ngOnInit()
          }
          await this.alert('Se cargo el fichero con exito', 'success');
        });
      }),
    ).subscribe();
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
